import React from "react"
import { useTranslation } from "react-i18next"

import ProtectedLayout from "layouts/Protected"
import * as PartnerApi from "features/Partner/api/PartnerApi"

import { useAuth, useAlert } from "hooks"
import { GenderTable } from "../Partials"
import FolderIcon from "components/Elements/Icons/Folder"

export const PartnerCollectionFolders = () => {
    const [partners, setPartners] = React.useState(null)
    const [filteredPartners, setFilteredPartners] = React.useState(null)
    const [currentGender, setCurrentGender] = React.useState(1)

    const { alert } = useAlert()
    const { t } = useTranslation()
    const { user, logout } = useAuth()
    
    const fetchData = React.useCallback(
        () => {
            ; (async () => {
                try {
                    const { res: getPartners, getError } = await PartnerApi.getPartners(user?.status)
                    if (getError()) throw getError()
                    const newPartners = getPartners.filter(member => member?.status !== 9).map((member) => {
                        return ({
                            managed_by: member?.managed_by,
                            status: member?.status,
                            social_reason: member?.entity_data?.raison_sociale,
                            gender: member?.gender,
                            commercial_name: member?.entity_data?.nom_commercial,
                            siret: member?.entity_data?.siret,
                            postal_code: member?.entity_data?.adresse?.code_postal,
                            town: member?.entity_data?.adresse?.ville,
                            client_number: member?.entity_id,
                            email: member?.entity_data?.mail,
                            phone: member?.entity_data?.telephone_1.replace("+33", "0")
                        })
                    })
                    setPartners(newPartners)
                } catch (error) {
                    console.error(error)
                    const erroMsg = error?.message?.toString()
                    if (erroMsg) alert("error", erroMsg)
    
                    if (["Access token is required."].includes(error?.error?.message)) logout()
    
                }
            })()
        },
        [] // eslint-disable-line
    )

    // fetch data on first load
    React.useEffect(() => fetchData(), []) // eslint-disable-line

    React.useEffect(() => {
        const filteredDatas = partners && partners.filter(p => {
            return p.gender === parseInt(currentGender)
        })
        setFilteredPartners(filteredDatas)
    }, [partners, currentGender]) // eslint-disable-line

    return (
        <ProtectedLayout className="px-7 py-7">
            <div className="l-container">
                <div className="c-section-title">
                    <div className="c-section-title__content">
                        <FolderIcon size={40} />
                        <h1 className="c-section-title__title c-h2 text-primary font-medium ml-5">
                            {t("folder.title", { ns: "partner" }) }
                        </h1>
                    </div>
                </div>

                <div className="c-submenu p-7">
                    <div className="flex items-center justify-start w-full">
                        <div className={"c-submenu__item px-5 "}>
                            <button type="button" onClick={() => setCurrentGender(1)} className={"flex " + (currentGender === 1 ? "active" : "")}>
                                {t("storeGender.horsAlsaceMoselle", { ns: "partner" })}
                            </button>
                        </div>
                        <div className={"c-submenu__item px-5 "}>
                            <button type="button" onClick={() => setCurrentGender(2)} className={"flex " + (currentGender === 2 ? "active" : "")}>
                                {t("storeGender.alsaceMoselle", { ns: "partner" })}
                            </button>
                        </div>
                        <div className={"c-submenu__item px-5 "}>
                            <button type="button" onClick={() => setCurrentGender(3)} className={"flex " + (currentGender === 3 ? "active" : "")}>
                                {t("storeGender.collectivite", { ns: "partner" })}
                            </button>
                        </div>
                        <div className={"c-submenu__item px-5 "}>
                            <button type="button" onClick={() => setCurrentGender(0)} className={"flex " + (currentGender === 0 ? "active" : "")}>
                                {t("storeGender.velociste", { ns: "partner" })}
                            </button>
                        </div>
                    </div>
                </div>

                <p className="mt-2 mb-7">{t("folder.description", { ns: "partner" }) }</p>

                <div className="c-card p-5 md:p-12">
                    {filteredPartners ?
                        <div>
                            <GenderTable
                                partnersList={filteredPartners}
                                className="pb-7"
                            /> 
                        </div>
                        :
                        <div className="flex justify-center items-center py-12">
                            <div className="c-spinner"></div>
                        </div>
                    }
                </div>
            </div>
        </ProtectedLayout>
    )
}